import { saveAs } from 'file-saver';

export const sortArray = (dataArray, key) => {
    if (!dataArray?.length) return [];

    return dataArray.sort((a, b) => sortFunction(a, b, key));
};

export const sortFunction = (a, b, key) => {
    const nameA = a[key].toUpperCase(); // ignore upper and lowercase
    const nameB = b[key].toUpperCase(); // ignore upper and lowercase

    if (nameA > nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }

    // names must be equal
    return 0;
};


const ParseFileNameFromContentDisposition = (contentDisposition) => {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
        return matches[1].replace(/['"]/g, '');
    }
    return '';
};

export const formatDateFunc = (date) => date.toString().replace(/GMT.*/g, '');

export const saveFile = (response) => {
    const headers = response.headers;
    const contentDisposition = headers['content-disposition'];
    const fileName = ParseFileNameFromContentDisposition(contentDisposition);

    saveAs(new Blob([response.data], { type: response.data.type }), fileName);
};

